<template lang="pug">
div.main-background
  .card
    card-panel
  .container-target
    active-goal.mb-6
    task-panel
</template>

<script>
import CardPanel from './CardPanel.vue'
import ActiveGoal from '../GoalPage/ActiveGoal.vue';
import TaskPanel from './TaskPanel.vue';
export default {
  name: 'MainPage',
  
  components: {
    CardPanel,
    ActiveGoal,
    TaskPanel
  },

  computed: {
  },

  methods: {
  }
}
</script>
<style scoped>
.main-background {
  background: linear-gradient(59.31deg, #5365E5 14.94%, #1976D2 55.08%, #01ADE4 92.56%);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.container-target {
  height: 100%;
  width: 100%;
  background: #FFFFFF;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-top-width: 1px;
}
</style>
